import logo from './logo.svg';
import './App.css';
import axios from "axios";
import { useState,useEffect } from "react";
import CryptoJS from 'crypto-js';
import 'bootstrap/dist/css/bootstrap.css';
function App() {

  const [canal, setCanal] = useState();
  const [cadenaStatic, setCadenaStatic] = useState();
  const [token, setToken] = useState();
  const [usuario,setUsuario]=useState();
  const [password,setPassword]=useState();
  const [cadena,setCadena]=useState();
  const [random,setRandom]=useState();
  const [base16,setBase16]=useState();
  const [cadenaSemilla,setCadenaSemilla]=useState();
  const [cadenaSemillaUtf8,setCadenaSemillaUtf8]=useState();
  const [cadenaEncriptada,setCadenaEncriptada]=useState();
  const [resultadoBus,setResultadoBus]=useState();
  const [urlBus,setUrlBus]=useState("http://cofic.instaticket.com.ec:9752/servicioIntegracionWS/ServicioWS/obtenerResultadoProduccionPost");
  const [urlToken,setUrlToken]=useState("http://cofic.instaticket.com.ec:9752/servicioIntegracionWS/ServicioWS/obtenerPublicToken");
  
  var keySize = 128;
var ivSize = 128;
var iterations = 100;

  useEffect(() => {
    setCanal("06");
    setCadenaStatic(
      "5vlbtzicr0146tmia071x4bme6guw96co5jpsv61ybop92mmmc5yex48kkgr3slenzwq52950ccbys9g055orcozcwpmvnx0x1si7e9onu8kq0nafh7386hxr0p7op6oac4dzbzgmopq06vpv2208exbbbfixjvz267cp8nrtcq4x9vhweai4pi0m90czoydlopmg6gjkpwv9xxmmgwl3juviqjsiht6nqrzlsgtbne5wf38u0jdv7ivti1e1hl1dc07jbqcn2w8l33mfpvbu5elechv51yj6v1nsi5riaev1gy10dtywyqllyjm2kwc955yqibtmnirry4pbzwazaujznozrj7wg7hxle6j6ddzkr15bf5fwcyyybvjxu32zi46uzntikhjg8pvhl7uu553029o8bkc04yvldmi20p7ujkpfhbefgpi081oj9ugwrkferrwnpa874lgbbs4wmgf2mzjn64v4pdrkpi1jr7lfiaknb6e92seam8zzqsk"
    );

  }, []);

  const getToken = async () => {
    const resToken = axios.get(
      urlToken,
      {
        params: {
          strParam: cadenaStatic,
          strParamCanal: canal,
        },
      }
    );
    return resToken;
   
  };

  const getBus = async (cadena,usuario,password) => {
    console.log("cadena",cadena)
    console.log("usuario",usuario)
    console.log("password",password)
    const resToken = axios.post(
      urlBus,
      {
        
          strParam: cadena,
          strUsuario: usuario,
          strPassword:password
        
      },{
        headers:{
          "Content-Type":"application/x-www-form-urlencoded"
        }
      }
    );
    return resToken;
   
  };

  const createPost= async ()=>{
    /// obtenemos el token del servidor
    let res= await getToken();
     
     console.log(res.data.token)
     setToken(res.data.token)

  
    /// buscamos un numero ramdom que me indica de donde inicia la cadena semilla
    const randomNum = Math.floor(Math.random() * 480) + 1;
    //18;// randomNumberInRange(1, 480);
    console.log(randomNum);
    setRandom(randomNum)

    /// de la cadena que retorno la ejecucion del primer servicio tomamos 32 caractrnes a partir del ramdom
    const cadenaSemilla = res.data.token.substring(randomNum, randomNum + 32);
    console.log("cadenaSemilla",cadenaSemilla);
    setCadenaSemilla(cadenaSemilla)

    /// convertimos el numero ramdom a base 16
    let controlToken= randomNum.toString(16);
    console.log(controlToken)
   
    /// rellenamos de cero a 4 digitos el numero ramdom
    controlToken=controlToken.toUpperCase().padStart( 4, "0");
    console.log(controlToken)
    setBase16(controlToken)
/// tenemos el key que se llamara la cadena semilla con la que el servidor pordra obtner la data
    const strToken=controlToken+"|"+canal+"|"+"01";
    console.log(strToken)
    setUsuario(strToken)
    setPassword("")

    /// parseamos a utf8 la cadena semilla
  const key =await CryptoJS.enc.Utf8.parse(cadenaSemilla)
  console.log("key",key)
  setCadenaSemillaUtf8(key)

    //var ciphertext = encrypt('Q001*|*P07*|*P00*|*PRS*|*12&&C~~4&&0~~12&&webuser~~12&&ipuser~~5&&1~~4&&0~~-6&&0*|*STOKENRC',cadenaSemilla);

    const value = "Q001*|*P07*|*P00*|*PRS*|*12&&C~~4&&0~~12&&webuser~~12&&ipuser~~5&&1~~4&&0~~-6&&0*|*STOKENRC";
                ///Q001*|*P07*|*P00*|*PRS*|*12&&C~~4&&0~~12&&webuser~~12&&ipuser~~5&&1~~4&&0~~-6&&0*|*STOKENRC/USR/PWD
                setCadena(value)

   const keyrr = CryptoJS.enc.Utf8.parse(cadenaSemilla); // AES-256 key (32 bytes)

   const encryptedHex = encryptAES(value, keyrr);
   console.log("Encrypted Value (HEX):", encryptedHex.toUpperCase());
   setCadenaEncriptada(encryptedHex)


    let bus =  await getBus(encryptedHex.toUpperCase(),strToken,"")
    console.log("bus",bus)

    setResultadoBus(bus.data.resultado.rs)

    


  }

  /// liberia se debe instalar 
  ///npm install crypto-js

  const CryptoJS = require("crypto-js");

function encryptAES(plaintext, key) {
  // Encrypt the plaintext using AES encryption in ECB mode
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    mode: CryptoJS.mode.ECB,   // Using ECB mode
    padding: CryptoJS.pad.Pkcs7 // Default padding is PKCS7
  });

  // Convert the ciphertext to a hexadecimal string
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}



  return (
    <>
      <div class="container-fluid">
        <form>

            <div class="mb-3">
                <label for="urlBus" class="form-label">Url Bus Post</label>
                <input type="text"  class="form-control" id="urlBus" placeholder="Url Bus" value={urlBus} ></input>
            </div>
            <div class="mb-3">
                <label for="urlToken" class="form-label">Url Token</label>
                <input type="text"  class="form-control" id="urlToken" placeholder="Url Token" value={urlToken} ></input>
            </div>
            <div class="mb-3">
                <label for="cadenaEstatica" class="form-label">Cadena Estatica que se genrera en el lado del Servidor</label>
                <input type="text"  class="form-control" id="cadenaEstatica" placeholder="Cadena Estatica" value={cadenaStatic}></input>
            </div>
            <div class="mb-3">
                <label for="canal" class="form-label">Canal</label>
                <input type="text"  class="form-control" id="canal" placeholder="Canal" value={canal}></input>
            </div>
            <div class="mb-3">
                <label for="publicToken" class="form-label">Token Recuperado al llamar a el Public Token</label>
                <input type="text"  class="form-control" id="publicToken" placeholder="public Token" value={token} disabled></input>
            </div>
            <div class="mb-3">
                <label for="random" class="form-label"> buscamos un numero ramdom que me indica de donde inicia la cadena semilla randomNumberInRange(1, 480);</label>
                <input type="text"  class="form-control" id="random" placeholder="Random" value={random} disabled></input>
            </div>
            <div class="mb-3">
                <label for="base16" class="form-label"> convertimos el numero ramdom a base 16 rellenamos de cero a 4 digitos el numero ramdom</label>
                <input type="text"  class="form-control" id="base16" placeholder="Convertir Base 16" value={base16} disabled></input>
            </div>
            <div class="mb-3">
                <label for="datosUsuario" class="form-label"> tenemos el key que se llamara la cadena semilla con la que el servidor pordra obtner la data</label>
                <input type="text"  class="form-control" id="datosUsuario" placeholder="Datos Usuario" value={usuario} disabled></input>
            </div>
            <div class="mb-3">
                <label for="cadenaSemilla" class="form-label"> Cadena Semilla se corta la cadena desde el valor ramdom + 32</label>
                <input type="text"  class="form-control" id="cadenaSemilla" placeholder="Cadena Semilla" value={cadenaSemilla} disabled></input>
            </div>
            <div class="mb-3">
                <label for="cadenaSemillaUtf8" class="form-label"> parseamos a utf8 la cadena semilla</label>
                <input type="text"  class="form-control" id="cadenaSemillaUtf8" placeholder="Cadena Semilla Utf 8" value={cadenaSemillaUtf8} disabled></input>
            </div>
            <div class="mb-3">
                <label for="cadenaBus" class="form-label"> Cadena con estructura Bus Asvesot
                </label>
                <input type="text"  class="form-control" id="cadenaBus" placeholder="Cadena Bus" value={cadena} ></input>
            </div>
            <div class="mb-3">
                <label for="resultado" class="form-label"> Resultado Cadena Encriptada
                </label>
                <textarea class="form-control" id="resultado" rows="3" value={cadenaEncriptada}></textarea>
            </div>
            <div class="mb-3">
                <label for="resultadoBus" class="form-label"> Resultado Bus
                </label>
                <textarea class="form-control" id="resultadoBus" rows="3" value={resultadoBus}></textarea>
            </div>
           
            
        </form>
      </div>
      <button onClick={createPost}>Create Post</button>
    </>
    
      
  );
}

export default App;
